import { AbstractControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { formatDate } from '@angular/common';
/**
 * 
 * @param control Control that has the validatior defined
 * @param form Complete form
 * @param options A validation function specific option object. Example: 
 * @returns true if validation passed. An object with the validation id and a message property inside if failed. Example: { "date": { message: "Something went wrong"}}
 */

export function dateFormatValidator(control: AbstractControl, form: FormlyFieldConfig, options: any = {}) {
  const model = control.value;
  let formattedDate: any;

  if (!model) {
    return null; // Field is empty, no validation required.
  }

  // 091423 - valid date with min length 6
  if (control.value.length > 5) {
    try {
      const regex = /[.\-\\/]/;
      let temp = "";
      if (control.value.length === 6 && regex.test(control.value) === false) { // converting 091423((length 6) to mm/dd/yyyy format (length 10)
        temp = control.value.slice(0, 2) + " " + control.value.slice(2, control.value.length - 2) + " " + control.value.slice(control.value.length - 2);
        formattedDate = formatDate(temp, 'MM/dd/yyyy', 'en-US');
      } else if (control.value.length === 7 && regex.test(control.value) === false) { // converting 09aug23((length 7) to mm/dd/yyyy format (length 10)
        temp = control.value.slice(0, 2) + " " + control.value.slice(2, control.value.length - 2) + " " + control.value.slice(control.value.length - 2);
        formattedDate = formatDate(temp, 'MM/dd/yyyy', 'en-US');

      } else if (control.value.length === 8 && regex.test(control.value) === false) { // converting 09012023((length 8) to mm/dd/yyyy format (length 10)
        temp = control.value.slice(0, 2) + " " + control.value.slice(2, control.value.length - 4) + " " + control.value.slice(control.value.length - 4);
        formattedDate = formatDate(temp, 'MM/dd/yyyy', 'en-US');
      }

      else { // showing error for numeric value greater than 8
        if (/^\d+$/.test(control.value) && control.value.length > 8) {
          return {
            'dateFormat': {
              message: 'Please enter date as mm/dd/yyyy'
            }
          };
        }
        // 01/05/2023 - valid date with length 10 (with separator)
        formattedDate = formatDate(control.value, 'MM/dd/yyyy', 'en-US');
      }

      if (!/^([1-9]|0[1-9]|1[012])[- //.]([1-9]|0[1-9]|[12][0-9]|3[01])[- //.](\d\d\d\d)$/.test(formattedDate)) {
        return {
          'dateFormat': {
            message: 'Please enter date as mm/dd/yyyy'
          }
        };
      }

      if (formattedDate !== control.value) control.patchValue(formattedDate, { ...options, emitEvent: false, onlySelf: true });
      const currentDate = new Date();
      const enteredDate = new Date(formattedDate);

      // when options.condition === ">" coming from template
      if (options.condition && options.condition === ">") {
        if (enteredDate > currentDate) {
          return {
            'dateFormat': {
              message: "provide today's date or a date prior to today."
            }
          };
        }
      } else if (options.condition && options.condition === "<>") {// when options.condition === "<>" coming from template

        // when fromDate and toDate coming from template
        if (options.fromDate && options.toDate) {
          const fromDate = new Date(options.fromDate);
          const fromYear = fromDate.getFullYear();

          // when toDate is today date.
          if (options.toDate === "todayDate") {
            const toDate = currentDate;
            if (fromDate < enteredDate && enteredDate > toDate) {
              return {
                'dateFormat': {
                  message: "Please enter a date between" + " " + fromYear + " " + "and today's date."
                }
              };
            }
            if (fromDate > enteredDate && enteredDate < toDate) {

              return {
                'dateFormat': {
                  message: "Please enter a date between" + " " + fromYear + " " + "and today's date."
                }
              };
            }
          }

          // when toDate is specific date.
          if (options.toDate !== "todayDate") {
            let toDate: Date;

            // when toDate is calculated with the help of today's date and expiry years.
            if (options.toDate === "withExpiry" && options.expireYears) {
              let expireYears = +(options.expireYears);
              let futureDate: Date;
              futureDate = addYears(currentDate, expireYears); // Calculate date 10 years ahead
              toDate = futureDate;

              function addYears(date: Date, years: number): Date {
                const newDate = new Date(date);
                newDate.setFullYear(date.getFullYear() + years);
                return newDate;
              }

              if (fromDate < enteredDate && enteredDate > toDate) {
                return {
                  'dateFormat': {
                    message: "The expire date should be between" + " " + options.fromDate + " " + "and" + " " + expireYears + " " + "years after today's date" + "."
                  }
                };
              }
              if (fromDate > enteredDate && enteredDate < toDate) {
                return {
                  'dateFormat': {
                    message: "The expire date should be between" + " " + options.fromDate + " " + "and" + " " + expireYears + " " + "years after today's date" + "."
                  }
                };
              }

            } else { // when toDate is proper given like 10/23/2024.
              toDate = new Date(options.toDate);

              if (fromDate < enteredDate && enteredDate > toDate) {
                return {
                  'dateFormat': {
                    message: "Please enter a date between" + " " + options.fromDate + " " + "and" + " " + options.toDate + "."
                  }
                };
              }
              if (fromDate > enteredDate && enteredDate < toDate) {
                return {
                  'dateFormat': {
                    message: "Please enter a date between" + " " + options.fromDate + " " + "and" + " " + options.toDate + "."
                  }
                };
              }

            }

          }
        }
      }

    } catch (e) {
      console.error(e);
    }
  }

  if (!control.value || !/^([1-9]|0[1-9]|1[012])[- //.]([1-9]|0[1-9]|[12][0-9]|3[01])[- //.](\d\d\d\d)$/.test(formattedDate)) {
    return {
      'dateFormat': {
        message: 'Please enter date as mm/dd/yyyy'
      }
    };
  }

  return null; // Date is valid.
}

